module.exports = __webpack_public_path__ + "static/media/uOttawa.f93a3b3a.png";